/* Script all functions
------------------------------------------------------------------------------*/

// Function to create and append SVG to an element
const mainHeader = document.querySelector('.main-header');

export const appendSVGBtn = (element, iconId, width, height) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
    svg.setAttribute('fill', 'currentColor');

    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', iconId);

    svg.appendChild(use);
    element.appendChild(svg);
};

export const initSVGBtns = () => {
    document.querySelectorAll('.btn-link, .-icon-rss, .btn-link-video').forEach((element) => {
        // Skip if element already contains an SVG
        if (element.querySelector('svg')) {
            return;
        }

        if (element.classList.contains('btn-link')) {
            appendSVGBtn(element, '#icon-btn-arrow', '16', '16');
        } else if (element.classList.contains('-icon-rss')) {
            appendSVGBtn(element, '#icon-rss', '16', '16');
        } else if (element.classList.contains('btn-link-video')) {
            appendSVGBtn(element.querySelector('.icon'), '#icon-video', '16', '16');
        }
    });

    document.querySelectorAll('a, button').forEach(function(element) {
        if (element.querySelector(':scope > svg')) {
            return;
        }
        if (element.matches('.heateor_sss_button_linkedin, .a2a_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin2', '20', '20');
        } else if (element.matches('.heateor_sss_button_x, .a2a_button_x')) {
            appendSVGBtn(element, '#icon-x', '20', '20');
        } else if (element.matches('.heateor_sss_facebook, .a2a_button_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '20', '20');
        } else if (element.matches('.heateor_sss_more, .addtoany_share')) {
            appendSVGBtn(element, '#icon-share', '20', '20');
        }
    });

    document.querySelectorAll('.heateor_sss_sharing_ul > a').forEach(function(el) {
        el.removeAttribute('style');
    });
};

/* Header add class and slide up top bar */
export const headeraddClass = () => {
    if (!mainHeader) {
        return;
    }

    const handleScroll = () => {
        const currentScroll = window.scrollY;
        if (currentScroll) {
            mainHeader.classList.add('stuck');
        } else {
            mainHeader.classList.remove('stuck');
        }
    };

    // Bind scroll listener
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
};

/* Slide Up, Down and Toggle Fucntion Start */
export const slideUp = (element, duration = 500, callback = null) => {
    const style = window.getComputedStyle(element);
    const paddingTop = style.paddingTop;
    const paddingBottom = style.paddingBottom;
    const marginTop = style.marginTop;
    const marginBottom = style.marginBottom;

    element.style.height = element.offsetHeight + 'px';
    // element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
    element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
    element.offsetHeight;

    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    setTimeout(() => {
        element.style.display = 'none';

        // Reset all styles
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');

        // Optionally reset to original
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;

        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
};

export const slideDown = (element, duration = 500, callback = null) => {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;

    if (display === 'none') {
        display = 'block';
    }
    element.style.display = display;

    const height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    element.offsetHeight; // force reflow

    // element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
    element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');

    setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');

        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
};

export const slideToggle = (element, duration = 500) => {
    if (window.getComputedStyle(element).display === 'none') {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
};
/* Slide Up, Down and Toggle Fucntion End */


/* same-height element start */
export const sameHeight = (elemSelector, heightType) => {
    const elements = document.querySelectorAll(elemSelector);
    let maxHeight = 0;
    heightType = heightType === undefined ? 'min-height' : 'height';
    elements.forEach(el => {
        el.style[heightType] = 'auto';
    });
    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    elements.forEach(el => {
        el.style[heightType] = maxHeight + 'px';
    });
};
/* same-height element end */

/* Fade In function Start */
export const updateFocusedClass = (fields) => {
    fields.forEach((field) => {
        const fieldWrap = field.closest('.gfield, .field');
        if (!fieldWrap) { return; }

        const checkValue = () => {
            const value = field.value;

            if (value && value !== '(___) ___-____') {
                fieldWrap.classList.add('focused');
            } else {
                fieldWrap.classList.remove('focused');
            }
        };

        const onFocus = () => {
            fieldWrap.classList.add('focused', 'focused_effect');
        };

        const onBlur = () => {
            fieldWrap.classList.remove('focused_effect');
            checkValue();
        };

        const onInput = () => {
            checkValue();
        };

        // initial state
        checkValue();

        field.addEventListener('focus', onFocus);
        field.addEventListener('blur', onBlur);
        field.addEventListener('input', onInput);
    });
};
/* form focus end */

/* Fade function Start */
export const fadeIn = (el, duration = 400, callback) => {
    el.style.opacity = 0;
    el.style.display = 'block';
    const start = performance.now();

    function animate(time) {
        let progress = (time - start) / duration;
        if (progress > 1) { progress = 1; }
        el.style.opacity = progress;

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else if (callback) {
            callback();
        }
    }
    requestAnimationFrame(animate);
};

// Fade Out function
export const fadeOut = (el, duration = 400, callback) => {
    el.style.opacity = 1;
    const start = performance.now();

    function animate(time) {
        let progress = (time - start) / duration;
        if (progress > 1) { progress = 1; }
        el.style.opacity = 1 - progress;

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            el.style.display = 'none';
            if (callback) { callback(); }
        }
    }

    requestAnimationFrame(animate);
};

/* Fade function End */

export const initAccordion = (selector) => {
    const accordionSections = document.querySelectorAll(selector);

    accordionSections.forEach(section => {
        const items = section.querySelectorAll('.accordion-item');

        items.forEach(item => {
            const title = item.querySelector('.accordion-title');
            const content = item.querySelector('.accordion-content');

            if (!title || !content) {
                return;
            }

            title.addEventListener('click', () => {
                const parent = item.parentElement;
                const isOpen = item.classList.contains('is-active');

                // Close siblings
                Array.from(parent.children).forEach(sibling => {
                    if (sibling !== item && sibling.classList.contains('is-active')) {
                        sibling.classList.remove('is-active');
                        const siblingContent = sibling.querySelector('.accordion-content');
                        if (siblingContent) {
                            slideUp(siblingContent);
                        }
                    }
                });

                // Toggle current
                if (isOpen) {
                    item.classList.remove('is-active');
                    slideUp(content);
                } else {
                    item.classList.add('is-active');
                    slideDown(content);
                }
            });
        });
    });
};